export const ROLE_HIERARCHY = ['free', 'standard', 'pro', 'admin'];
